import { createRoute } from "@tanstack/react-router";

import { shellRoute } from "@platform/shell.route";
import { HomePage } from "./home.page";

export const homeRoute = createRoute({
	getParentRoute: () => shellRoute,
	path: "/",
	component: HomePage,
});
